import { React, useCallback, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  CardBody,
  Card,
  CardHeader,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  Badge,
  FormGroup,
  Input,
  Label,
  CardFooter,
} from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { publicJobsourceOptions } from "../../../Constant";
import {
  publicApplyJobRequest,
  publicApplyJobReset,
} from "../../../redux/public/public_apply_job/actions";
import { fetchLocationsRequest } from "../../../redux/location/actions";
import { showToast } from "../../../Components/Common/Toast";
import { useParams, useNavigate } from "react-router-dom";
import {
  customOptionsStyle,
  monthsOptions,
  experienceOptions,
} from "../../../Constant";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import {
  extractAfterLastHyphen,
  countryPhoneLengthMap,
} from "../../Common/CommonFunction";
import { jobsourceOptions } from "../../../Constant";
import validator from "validator";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css"; // Import styles directly from react-phone-input-2
import { convertNumberToWords, handleNumberInput } from "../../Common/CommonFunction";
import { fetchEducationRequest } from "../../../redux/education/actions";
const ApplyNowModal = (props) => {
  const { id } = useParams();

  const dispatch = useDispatch();
  const [showReferralInput, setShowReferralInput] = useState(false);
  const [phoneNumberMaxLength, setPhoneNumberMaxLength] = useState(10); // Default max length for phone1
  const [phoneNumber2MaxLength, setPhoneNumber2MaxLength] = useState(10); // Default max length for phone2
  const navigate = useNavigate();
  const [locationOptions, setLocationOptions] = useState([]);
  const [educationOptions, setEducationOptions] = useState([]);
  const [formData, setFormData] = useState({
    full_name: "",
    email1: "",
    email2: "",
    phone1: "",
    phone2: "",
    country_code1: "91",
    country_code2: "91",
    jobseeker_location: null,
    preferred_location: null,
    relevant_experience_years: null,
    relevant_experience_months: null,
    jobseeker_notice_period: "",
    jobseeker_preferred_salary: "",
    jobseeker_current_salary: "",
    resume: null,
    job_source: {
      value: "CANDIDATE_APPLYING_DIRECTLY",
      label: "Candidate Applying Direct",
    },
    referral_email: "",
    education: [],
  });

  const [errors, setErrors] = useState({});
  const publicApplyJobReducerData = useSelector(
    (state) => state.publicApplyJobReducer
  );
  console.log("publicApplyJobReducerData2", publicApplyJobReducerData);

  // Fetching and updating location data
  let locationReducerData = useSelector((state) => state.locationReducer);
  let locationData = locationReducerData.data.data;

  useEffect(() => {
    locationData = locationData || [];
    setLocationOptions(locationData);
  }, [locationData]);

  const handleLocationFocus = () => {
    const fetchData = async () => {
      try {
        const keyword = ""; // Set your keyword value here
        dispatch(fetchLocationsRequest(keyword));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  };

  const handleLocationInputChange = useCallback((inputValue) => {
    const fetchData = async () => {
      try {
        dispatch(fetchLocationsRequest(inputValue));
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  let educationReducerData = useSelector((state) => state.educationReducer);
  let educationData = educationReducerData.data.data;

  useEffect(() => {
    educationData = educationData || [];
    setEducationOptions(educationData);
  }, [educationData]);

  const handleEducationFocus = () => {
    // This function will be called when the location dropdown is focused
    // You can trigger your API call here
    const fetchData = async () => {
      try {
        const keyword = ""; // Set your keyword value here
        dispatch(fetchEducationRequest(keyword));
      } catch (error) {
        console.error(error);
      }
    };

    // Call the fetchData function when the location dropdown is focused
    fetchData();
  };

  // Callback to handle location input change
  const handleEducationInputChange = useCallback((inputValue) => {
    // Fetch data based on the inputValue (keyword)
    const fetchData = async () => {
      try {
        dispatch(fetchEducationRequest(inputValue));
      } catch (error) {
        // Handle any errors if necessary
      }
    };

    // Call the fetchData function when the location input changes
    fetchData();
  }, []);

  const handleEducationChange = (selectedOptions) => {
    const updatedErrors = { ...errors, education: "" };
    setErrors(updatedErrors);

    // Update the form state with selected values
    setFormData({ ...formData, education: selectedOptions });
  };

  const handleLocationsChange = (selectedOptions) => {
    const updatedErrors = { ...errors, jobseeker_location: "" };
    setErrors(updatedErrors);
    setFormData({ ...formData, jobseeker_location: selectedOptions });
  };
  const handlePreferredLocationsChange = (selectedOptions) => {
    const updatedErrors = { ...errors, preferred_location: "" };
    setErrors(updatedErrors);
    setFormData({ ...formData, preferred_location: selectedOptions });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedErrors = { ...errors, [name]: "" };
    setErrors(updatedErrors);
    setFormData({ ...formData, [name]: value });
    // Validation logic for current and expected CTC
    const currentSalary = parseFloat(formData.jobseeker_current_salary) || 0; // Get current salary from formData
    const preferredSalary = parseFloat(value) || 0; // Get preferred salary from the current input value

    // Check if the field being updated is the preferred salary
    if (name === "jobseeker_preferred_salary") {
      if (preferredSalary < currentSalary) {
        // Set the error message if preferred salary is less than current salary
        updatedErrors[name] = "Expected CTC cannot be less than Current CTC";
        setErrors(updatedErrors); // Update the errors state
      }
    }
  };

  const handleCodeChange = (value, country) => {
    // Extract only the phone number without the country code
    const phoneNumberWithoutCode = value
      .replace(`+${country.dialCode}`, "")
      .trim();
    // Removing non-digit characters and ensuring country code is included
    const formattedPhoneNumber = `+${country.dialCode}${value
      .replace(/\D/g, "")
      .slice(country.dialCode.length)}`;
    setFormData({
      ...formData,

      country_code1: country.dialCode,
      phone1: "",
    });
    // Update max length based on the selected country code
    const newMaxLength = countryPhoneLengthMap[country.dialCode] || 15; // default to 15 if not found
    setPhoneNumberMaxLength(newMaxLength); // This assumes you have a state that holds the max length
  };
  const handleCodeChange2 = (value, country) => {
    // Extract only the phone number without the country code
    const phoneNumberWithoutCode = value
      .replace(`+${country.dialCode}`, "")
      .trim();
    // Removing non-digit characters and ensuring country code is included
    const formattedPhoneNumber = `+${country.dialCode}${value
      .replace(/\D/g, "")
      .slice(country.dialCode.length)}`;
    setFormData({
      ...formData,

      country_code2: country.dialCode,
      phone2: "",
    });
    // Update max length based on the selected country code
    const newMaxLength = countryPhoneLengthMap[country.dialCode] || 15; // default to 15 if not found
    setPhoneNumber2MaxLength(newMaxLength); // This assumes you have a state that holds the max length
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    const file = files[0]; // Get the first file

    // Check if a file is selected
    if (file) {
      // Check file type
      const validFileTypes = [".pdf", ".doc", ".docx", ".txt"];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!validFileTypes.includes(`.${fileExtension}`)) {
        // Set error message if the file type is invalid
        setErrors((prevErrors) => ({
          ...prevErrors,
          resume: "Only .pdf, .doc, .docx, and .txt files are allowed",
        }));
        // Reset the file input
        e.target.value = null; // Reset the input field
        return; // Exit the function
      }

      // Check file size (5MB = 5 * 1024 * 1024 bytes)
      if (file.size > 5 * 1024 * 1024) {
        // Set error message if file size exceeds 5MB
        setErrors((prevErrors) => ({
          ...prevErrors,
          resume: "File size should not exceed 5MB",
        }));
        // Reset the file input
        e.target.value = null; // Reset the input field
      } else {
        // Clear the error if the file size and type are valid
        setErrors((prevErrors) => ({
          ...prevErrors,
          resume: "",
        }));
        // Update formData with the selected file
        setFormData({ ...formData, [name]: file });
      }
    } else {
      // Set error if no file is selected
      setErrors((prevErrors) => ({
        ...prevErrors,
        resume: "Resume is required",
      }));
      setFormData({ ...formData, [name]: null });
    }
  };

  const handleJobSourceChange = (selectedOption) => {
    setFormData({
      ...formData,
      job_source: selectedOption, // Store only the value
    });

    setErrors({
      ...errors,
      job_source: "",
    });
    // Check if the selected option is "EMPLOYEE REFERRAL"
    if (selectedOption && selectedOption.value === "EMPLOYEE_REFERRAL") {
      setShowReferralInput(true);
    } else {
      setShowReferralInput(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      const formDataObject = new FormData();

      formDataObject.append("jobseeker_full_name", formData.full_name);
      formDataObject.append("jobseeker_email1", formData.email1);
      formDataObject.append("jobseeker_email2", formData.email2);
      formDataObject.append("jobseeker_phone1", formData.phone1);
      formDataObject.append("jobseeker_phone2", formData.phone2);
      formDataObject.append("country_code1", formData.country_code1);
      formDataObject.append("country_code2", formData.country_code2);
      formDataObject.append("referral_email", formData.referral_email);
      formDataObject.append(
        "qualification",
        formData.education
          ? formData.education.map((edu) => edu.value).join(",")
          : ""
      );
      formDataObject.append(
        "jobseeker_location",
        formData.jobseeker_location ? formData.jobseeker_location.value : ""
      );
      formDataObject.append(
        "month_exp",
        formData.relevant_experience_months
          ? formData.relevant_experience_months.value
          : ""
      );
      formDataObject.append(
        "year_exp",
        formData.relevant_experience_years
          ? formData.relevant_experience_years.value
          : ""
      );
      formDataObject.append(
        "preferred_location",
        formData.preferred_location ? formData.preferred_location.value : ""
      );
      formDataObject.append(
        "jobseeker_notice_period",
        formData.jobseeker_notice_period
      );
      formDataObject.append(
        "jobseeker_preferred_salary",
        formData.jobseeker_preferred_salary
      );
      formDataObject.append(
        "jobseeker_current_salary",
        formData.jobseeker_current_salary
      );
      formDataObject.append("resume", formData.resume);
      formDataObject.append(
        "job_source",
        formData.job_source ? formData.job_source.value : ""
      );
      formDataObject.append("job_id", extractAfterLastHyphen(id)); // Replace with the actual job ID if dynamic

      dispatch(publicApplyJobRequest(formDataObject));
    } else {
      console.error("Form submission error:", errors);
    }
  };

  const validate = () => {
    let errors = {};
    let isValid = true;

    if (!formData.full_name) {
      errors.full_name = "Full name is required";
      isValid = false;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,6}$/;
    if (!formData.email1) {
      errors.email1 = "Email is required";
      isValid = false;
    } else if (!emailRegex.test(formData.email1)) {
      errors.email1 = "Please enter valid email";
      isValid = false;
    }

    if (formData.email2 && !emailRegex.test(formData.email2)) {
      errors.email2 = "Please enter valid email";
      isValid = false;
    }
    // Check if primary and secondary emails are identical
    if (
      formData.email1 &&
      formData.email2 &&
      formData.email1.trim() === formData.email2.trim()
    ) {
      errors.email2 = "Primary and secondary email addresses must not be identical";
      isValid = false;
    }

    const trimmedPhoneNumber = formData.phone1.trim();
    if (!trimmedPhoneNumber) {
      errors.phone1 = "Phone number is required";
      isValid = false;
    } else if (formData.country_code1 === "91" && trimmedPhoneNumber.length !== 10) {
      errors.phone1 = "Phone number must be 10 digits for India";
      isValid = false;
    } else if (formData.country_code1 === "91" && !/^[6-9]\d{9}$/.test(trimmedPhoneNumber)) {
      errors.phone1 = "Phone number cannot be start with 0 to 5";
      isValid = false;
    } else if (isNaN(trimmedPhoneNumber)) {
      errors.phone1 = "Phone number must be a valid number";
      isValid = false;
    } else if (/^0{10}$/.test(trimmedPhoneNumber)) { // Check for 0000000000
      errors.phone1 = "Phone number cannot be all zeros";
      isValid = false;
    } else if (!validator.isMobilePhone(trimmedPhoneNumber, "any", { strictMode: false })) {
      errors.phone1 = "Invalid phone number format";
      isValid = false;
    }


    const trimmedPhoneNumber2 = formData.phone2.trim();
    if (trimmedPhoneNumber2) {
      // Check for length if the country code is India
      if (formData.country_code2 === "91" && trimmedPhoneNumber2.length !== 10) {
        errors.phone2 = "Phone number must be 10 digits for India";
        isValid = false;
      }
      else if (formData.country_code2 === "91" && !/^[6-9]\d{9}$/.test(trimmedPhoneNumber2)) {
        errors.phone2 = "Phone number cannot be start with 0 to 5";
        isValid = false;
      }

      // Check if the phone number is a valid number
      else if (isNaN(trimmedPhoneNumber2)) {
        errors.phone2 = "Phone number must be a valid number";
        isValid = false;
      }
      // Check for all zeros
      else if (/^0{10}$/.test(trimmedPhoneNumber2)) { // Check for 0000000000
        errors.phone2 = "Phone number cannot be all zeros";
        isValid = false;
      }
      // Check for valid mobile phone format
      else if (!validator.isMobilePhone(trimmedPhoneNumber2, "any", { strictMode: false })) {
        errors.phone2 = "Invalid phone number format";
        isValid = false;
      }
    }

    // Check if primary and secondary phone numbers are identical
    if (
      trimmedPhoneNumber &&
      trimmedPhoneNumber2 &&
      trimmedPhoneNumber === trimmedPhoneNumber2
    ) {
      errors.phone2 =
        "Primary and secondary phone numbers must not be identical";
      isValid = false;
    }

    if (!formData.jobseeker_location) {
      errors.jobseeker_location = "Current location is required";
      isValid = false;
    }

    if (!formData.preferred_location) {
      errors.preferred_location = "Preferred location is required";
      isValid = false;
    }

    if (
      !formData.relevant_experience_years &&
      !formData.relevant_experience_months
    ) {
      errors.relevant_experience_years =
        "Relevant Experience (either in years or months) is required";
      isValid = false;
    }

    if (!formData.jobseeker_preferred_salary) {
      errors.jobseeker_preferred_salary = "Expected CTC is required";
      isValid = false;
    } else if (isNaN(formData.jobseeker_preferred_salary)) {
      errors.jobseeker_preferred_salary = "Expected CTC must be a number";
      isValid = false;
    } else if (parseFloat(formData.jobseeker_preferred_salary) < parseFloat(formData.jobseeker_current_salary)) {
      errors.jobseeker_preferred_salary = "Expected CTC cannot be less than Current CTC";
      isValid = false;
    }

    if (!formData.jobseeker_current_salary) {
      errors.jobseeker_current_salary = "Current CTC is required";
      isValid = false;
    } else if (isNaN(formData.jobseeker_current_salary)) {
      errors.jobseeker_current_salary = "Current CTC must be a number";
      isValid = false;
    }

    // Validate notice period
    if (!formData.jobseeker_notice_period) {
      errors.jobseeker_notice_period = "Notice period is required";
      isValid = false;
    } else if (isNaN(formData.jobseeker_notice_period)) {
      errors.jobseeker_notice_period = "Notice period must be a number";
      isValid = false;
    }

    // Check if resume has an error
    if (!formData.resume) {
      errors.resume = "Resume is required";
      isValid = false;
    } else if (formData.resume.size > 5 * 1024 * 1024) { // Check file size
      errors.resume = "File size should not exceed 5MB";
      isValid = false;
    }

    if (!formData.job_source) {
      errors.job_source = "Job source is required";
      isValid = false;
    }

    if (formData.job_source.value === "EMPLOYEE REFERRAL") {
      if (!formData.referral_email) {
        errors.referral_email = "Referral Email is required";
        isValid = false;
      }
    }
    if (!formData.education || formData.education.length === 0) {
      errors.education = "Education is required";
      isValid = false;
    }

    setErrors(errors);
    return isValid;
  };

  useEffect(() => {
    console.log("publicApplyJobReducerData:", publicApplyJobReducerData);
    if (
      publicApplyJobReducerData.status === true &&
      publicApplyJobReducerData.message !== ""
    ) {
      showToast("success", publicApplyJobReducerData.message);
      props.toggleModal();
      dispatch(publicApplyJobReset());
    } else if (
      publicApplyJobReducerData.status === false &&
      publicApplyJobReducerData.message !== ""
    ) {

      if (publicApplyJobReducerData.type == "email") {
        errors.referral_email = publicApplyJobReducerData.message;
      } else {
        showToast("error", publicApplyJobReducerData.message);
      }
      // props.toggleModal();
      dispatch(publicApplyJobReset());
    }
  }, [publicApplyJobReducerData, navigate, dispatch]);

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggleModal}
      centered
      className="modal-lg"
    >
      <Form onSubmit={handleSubmit} className="theme-form">
        <ModalHeader className="border-0" toggle={props.toggleModal}>
          <h4> Apply For This Job</h4>
        </ModalHeader>
        <ModalBody>
          <h5 className="mb-4 text-purple">Personal Information</h5>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label for="full_name">
                  Full Name
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  className="form-control form-control-sm"
                  type="text"
                  name="full_name"
                  id="full_name"
                  placeholder="Enter full name"
                  value={formData.full_name}
                  onChange={(e) => {
                    const { value } = e.target;

                    // Validates if the input value contains only alphabetic characters (and spaces)
                    if (/^[A-Za-z\s]*$/.test(value) && value.length <= 50) {
                      handleChange(e); // Call your existing handleChange function
                    }
                  }}
                />
                {errors.full_name && (
                  <small className="text-danger">{errors.full_name}</small>
                )}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>
                  Current Location
                  <span className="text-danger">*</span>
                </Label>
                <Select
                  name="jobseeker_location"
                  options={locationOptions}
                  isLoading={locationReducerData.isLoading}
                  placeholder="Select locations..."
                  value={formData.jobseeker_location}
                  onChange={handleLocationsChange}
                  onInputChange={handleLocationInputChange}
                  styles={customOptionsStyle}
                  onFocus={handleLocationFocus}
                />
                {errors.jobseeker_location && (
                  <small className="text-danger">
                    {errors.jobseeker_location}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>
                  Primary Phone
                  <span className="text-danger">*</span>
                </Label>
                <div className="d-flex">
                  <PhoneInput
                    style={{
                      width: "10px",
                      marginRight: "10px",
                    }}
                    inputProps={{
                      name: "phone",
                      autoFocus: true,
                      disabled: true,
                      // placeholder: "Enter country code",
                    }}
                    country={"in"} // Default country
                    value={formData.country_code1}
                    onChange={handleCodeChange}
                    inputStyle={{
                      width: "100px", // Adjust width to fit country code
                      height: "38px",
                      //padding: "0.375rem 2.2rem", // Adjust padding to fit correctly
                      paddingLeft: "3rem",
                      fontSize: "1rem",
                      lineHeight: "1.5",
                      color: "#495057",
                      backgroundColor: "#fff",
                      backgroundClip: "padding-box",
                      border: "1px solid #ced4da",
                      borderRadius: ".25rem",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                    }}
                    enableAreaCodes={false}
                  />
                  <Input
                    // type="number"
                    className="form-control form-control-sm"
                    placeholder="Enter phone number"
                    id="phone1"
                    name="phone1"
                    value={formData.phone1}
                    style={{ marginLeft: "95px" }} // Add margin to separate the fields
                    onInput={(e) => {
                      const value = e.target.value;
                      // Check if the value is a valid number and respects phoneNumberMaxLength
                      if (
                        (value === "" || /^[0-9]*$/.test(value)) && // Allow only digits
                        value.length <= phoneNumberMaxLength // Limit based on phoneNumberMaxLength
                      ) {
                        handleChange(e); // Call your existing handleChange function
                      }
                    }}
                  />
                </div>

                {errors.phone1 && (
                  <small className="text-danger">{errors.phone1}</small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="email">
                  Primary Email<span className="text-danger">*</span>
                </Label>
                <Input
                  className="form-control form-control-sm"
                  type="text"
                  name="email1"
                  id="email1"
                  placeholder="Enter email"
                  value={formData.email1}
                  onChange={handleChange}
                  maxLength={50}
                />
                {errors.email1 && (
                  <small className="text-danger">{errors.email1}</small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Secondary Phone</Label>
                <div className="d-flex">
                  <PhoneInput
                    style={{
                      width: "10px",
                      marginRight: "10px",
                    }}
                    inputProps={{
                      name: "phone",
                      autoFocus: true,
                      disabled: true,
                      // placeholder: "Enter country code",
                    }}
                    country={"in"} // Default country
                    value={formData.country_code2}
                    onChange={handleCodeChange2}
                    inputStyle={{
                      width: "100px", // Adjust width to fit country code
                      height: "38px",
                      //padding: "0.375rem 2.2rem", // Adjust padding to fit correctly
                      paddingLeft: "3rem",
                      fontSize: "1rem",
                      lineHeight: "1.5",
                      color: "#495057",
                      backgroundColor: "#fff",
                      backgroundClip: "padding-box",
                      border: "1px solid #ced4da",
                      borderRadius: ".25rem",
                      transition:
                        "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                    }}
                    enableAreaCodes={false}
                  />
                  <Input
                    // type="number"
                    className="form-control form-control-sm"
                    placeholder="Enter phone number"
                    id="phone2"
                    name="phone2"
                    value={formData.phone2}
                    onInput={(e) => {
                      const value = e.target.value;
                      // Check if the value is a valid number and respects phoneNumberMaxLength
                      if (
                        (value === "" || /^[0-9]*$/.test(value)) && // Allow only digits
                        value.length <= phoneNumber2MaxLength // Limit based on phoneNumberMaxLength
                      ) {
                        handleChange(e); // Call your existing handleChange function
                      }
                    }}
                    style={{ marginLeft: "95px" }} // Add margin to separate the fields
                  />
                </div>

                {errors.phone2 && (
                  <small className="text-danger">{errors.phone2}</small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label for="email2">Secondary Email </Label>
                <Input
                  className="form-control form-control-sm"
                  type="text"
                  name="email2"
                  id="email2"
                  placeholder="Enter second email"
                  value={formData.email2}
                  onChange={handleChange}
                  maxLength={50}
                />
                {errors.email2 && (
                  <small className="text-danger">{errors.email2}</small>
                )}
              </FormGroup>
            </Col>
          </Row>
          <h5 className="mb-4 text-purple">Job Preferences</h5>

          <Row>
            <Col md="6">
              <FormGroup>
                <Label>
                  Preferred Location
                  <span className="text-danger">*</span>
                </Label>
                <Select
                  name="preferred_location"
                  options={locationOptions}
                  isLoading={locationReducerData.isLoading}
                  placeholder="Select locations..."
                  value={formData.preferred_location}
                  onChange={handlePreferredLocationsChange}
                  onInputChange={handleLocationInputChange}
                  styles={customOptionsStyle}
                  onFocus={handleLocationFocus}
                />
                {errors.preferred_location && (
                  <small className="text-danger">
                    {errors.preferred_location}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label for="jobseeker_notice_period">
                  Notice Period
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  // type="number"
                  name="jobseeker_notice_period"
                  className="form-control form-control-sm"
                  placeholder="Notice Period"
                  onInput={(e) => handleNumberInput(e, handleChange, 0, 365)}
                  value={formData.jobseeker_notice_period}
                />
                {errors.jobseeker_notice_period && (
                  <small className="text-danger">
                    {errors.jobseeker_notice_period}
                  </small>
                )}
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label for="jobseeker_current_salary">
                  Current CTC <span className="text-danger">*</span>
                </Label>
                <Input
                  // type="number"
                  name="jobseeker_current_salary"
                  className="form-control form-control-sm"
                  placeholder="Current ctc"
                  onInput={(e) => handleNumberInput(e, handleChange, 0, 990000000)}
                  value={formData.jobseeker_current_salary}
                />
                {formData.jobseeker_current_salary &&
                  !isNaN(formData.jobseeker_current_salary) && (
                    <>
                      <small className="text-muted text-capitalize">
                        {convertNumberToWords(
                          parseFloat(formData.jobseeker_current_salary)
                        )}
                      </small><br /></>
                  )}
                {errors.jobseeker_current_salary && (
                  <small className="text-danger">
                    {errors.jobseeker_current_salary}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label for="jobseeker_preferred_salary">
                  Expected CTC <span className="text-danger">*</span>
                </Label>
                <Input
                  // type="number"
                  name="jobseeker_preferred_salary"
                  className="form-control form-control-sm"
                  placeholder="Expected ctc"
                  onInput={(e) => handleNumberInput(e, handleChange, 1, 990000000)}
                  value={formData.jobseeker_preferred_salary}
                />
                {formData.jobseeker_preferred_salary &&
                  !isNaN(formData.jobseeker_preferred_salary) && (
                    <>
                      <small className="text-muted text-capitalize">

                        {convertNumberToWords(
                          parseFloat(formData.jobseeker_preferred_salary)
                        )}

                      </small><br /></>
                  )}
                {errors.jobseeker_preferred_salary && (
                  <small className="text-danger">
                    {errors.jobseeker_preferred_salary}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md={12}>
              <Label>
                Relevant Experience <span className="font-danger">*</span>
              </Label>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Select
                  options={experienceOptions}
                  value={formData.relevant_experience_years}
                  onChange={(selectedOption) => {
                    setFormData({
                      ...formData,
                      relevant_experience_years: selectedOption,
                    });
                    setErrors({ ...errors, relevant_experience_years: "" });
                  }}
                />{" "}
                {errors.relevant_experience_years && (
                  <small className="text-danger">
                    {errors.relevant_experience_years}
                  </small>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Select
                  options={monthsOptions}
                  value={formData.relevant_experience_months}
                  onChange={(selectedOption) => {
                    setFormData({
                      ...formData,
                      relevant_experience_months: selectedOption,
                    });
                    setErrors({ ...errors, relevant_experience_years: "" });
                  }}
                />
              </FormGroup>
            </Col>

            <Col md="6">
              <FormGroup>
                <Label>Job Source</Label>
                <span className="text-danger">*</span>
                <Select
                  options={publicJobsourceOptions}
                  value={formData.job_source}
                  onChange={handleJobSourceChange}
                  placeholder="Select job source..."
                />
                {errors.job_source && (
                  <div className="invalid-feedback d-block">
                    {errors.job_source}
                  </div>
                )}
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>
                  Education (Minimun Qualifications)
                  <span className="text-danger">*</span>
                </Label>
                <Select
                  isMulti
                  options={educationOptions}
                  isLoading={educationReducerData.loading}
                  placeholder="Select education..."
                  value={formData.education}
                  onChange={handleEducationChange}
                  styles={customOptionsStyle}
                  onInputChange={handleEducationInputChange}
                  onFocus={handleEducationFocus}
                />

                {errors.education && (
                  <small className="text-danger">{errors.education}</small>
                )}
              </FormGroup>
            </Col>
            {showReferralInput && (
              <Col md="6">
                <FormGroup>
                  <Label>Referral Email</Label>
                  <span className="text-danger">*</span>
                  <Input
                    type="text"
                    name="referral_email"
                    className="form-control form-control-sm"
                    placeholder="Enter referral email..."
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        referral_email: e.target.value,
                      })
                    }
                    value={formData.referral_email}
                  />

                  {errors.referral_email && (
                    <small className="text-danger">
                      {errors.referral_email}
                    </small>
                  )}
                </FormGroup>
              </Col>
            )}
          </Row>
          <h5 className="mb-4 text-purple">Document Upload</h5>
          <Row>
            <Col md={12}>
              <FormGroup>
                <Label for="relevant_experience_months">
                  CV
                  <span className="text-danger">*</span>
                </Label>
                <Input
                  type="file"
                  id="resume"
                  name="resume"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx,.txt"
                // invalid={!!errors.resume}
                />
                {errors.resume && (
                  <small className="text-danger">
                    {errors.resume}
                  </small>
                )}
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="text-end">
          <Button
            color="secondary"
            type="submit"
            name="submit"
            className="me-1"
            disabled={publicApplyJobReducerData.isLoading}
          >
            Submit
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ApplyNowModal;